import { A as push, O as spread_attributes, P as bind_props, D as pop } from "./index2.js";
import "./Select.svelte_svelte_type_style_lang.js";
function Input($$payload, $$props) {
  push();
  let { value = void 0, $$slots, $$events, ...props } = $$props;
  $$payload.out.push(`<input${spread_attributes({ value, ...props }, "svelte-11ylyjv")}/>`);
  bind_props($$props, { value });
  pop();
}
export {
  Input as I
};
